module.exports = __webpack_public_path__ + "img/dd4.da102c70.png";